import React, { useEffect, useState } from "react";
import { Box, Button, Card, FormLabel, Grid, Stack, Tab, Tabs, Toolbar, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import ShareIcon from '@mui/icons-material/Share';
import { EditableTextField } from "../Shared/FormItems";
import { ChangeProps } from "../Lessons/Show";
import { Solution } from "../../types/Solutions";
import LessonSummary from "../Lessons/Summary";
import { Lesson } from "../../types/Lessons";
import ActionMenu from "./Menu";

const Summary = (props: { solution: Solution, editable?: boolean } & ChangeProps ) => {

  const [copyLink, shouldCopyLink] = useState<boolean>(false);
  const [currentLesson, setCurrentLesson] = useState<Lesson>(props.solution.lessons[0]);

  useEffect(() => {
    if (typeof(props.solution) === "undefined" || !copyLink || !props.solution.url) { return }
    navigator.clipboard.writeText(props.solution.url);
  }, [copyLink]);

  const shareDialog = () => {
    if (typeof(props.solution) === "undefined") { return }
    if (typeof(navigator.share) !== "undefined") {
      navigator.share({url: props.solution.url}).then(fulfilled => {
        if (typeof(fulfilled) === "undefined") {
          shouldCopyLink(true);
        }
      }).catch(rejected => shouldCopyLink(true));
      return;
    }
  }

  return <>
    <Card sx={{mb: 3}}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <Stack direction="row" alignItems="center" spacing={4}>
            <Box flexGrow={1}>
              <FormLabel><strong style={{textDecoration: 'underline'}}>Solution</strong> from {dayjs.unix(props.solution.created_at).format("ll")} { props.solution.resolved_at && <> / Resolved at: {dayjs.unix(props.solution.resolved_at).format("lll")}</> }</FormLabel>

              <Stack direction="row" alignItems="center" gap={0.5}>
                { props.editable ? <EditableTextField
                                        placeholderElement={<h3 style={{marginBottom: 0}}>{props.solution.title}</h3>}
                                        placeholder="Enter a title for the solution"
                                        rows={1}
                                        onSave={value => props.onSave({title: value}) }
                                        defaultValue={props.solution.title} /> : <h3 style={{marginBottom: 0}}>{props.solution.title}</h3> }
              </Stack>
            </Box>

            <Toolbar disableGutters>
              <Tooltip 
                title={`Link copied`} 
                open={copyLink}>
                  <Button
                    size="small"
                    variant="text"
                    color="secondary"
                    startIcon={<ShareIcon />}
                    onClick={shareDialog}>Share</Button>
              </Tooltip>

              <ActionMenu {...props} />

            </Toolbar>
          </Stack>
        </Grid>
      </Grid>
    </Card>

    <Tabs onChange={(e, newValue) => setCurrentLesson(newValue)} indicatorColor="primary" textColor="secondary">
      { props.solution.lessons.map((lesson, index) => <Tab value={lesson} label={lesson.headline} sx={{bgcolor: currentLesson?.id === lesson.id ? "var(--color-white)" : "var(--color-greyDark)", textTransform: "none", color: currentLesson?.id === lesson.id ? "var(--text-primary)" : "var(--text-secondary)", borderTopLeftRadius: index === 0 ? "var(--border-radius)" : "0"}} style={{fontFamily: 'var(--header-font)'}} /> ) }
    </Tabs>

    <Card sx={{borderTopLeftRadius: "0 !important", borderTopRightRadius: "0 !important"}}>
      { props.solution.lessons.map(lesson => <Box key={lesson.id} hidden={currentLesson?.id !== lesson.id} >
        <LessonSummary lesson={lesson} compact onSave={() => {}} />
      </Box>)}
    </Card>
  </>
}

export default Summary;